/**
 * Asset section GetStarted method configurations
 *
 * Defines the available methods for getting started with asset population:
 * 1. Seeds - Define discovery starting points (domains, IPs, web apps)
 * 2. Integrations - Connect cloud providers and external services
 * 3. Import - Upload existing asset data from various formats
 */

import { ArrowUpTrayIcon } from '@heroicons/react/24/outline';
import {
  Integrations as IntegrationsIcon,
  Seeds as SeedsIcon,
} from '@praetorian-chariot/ui';

import type { GetStartedMethod } from '@/components/modals/GetStartedModal';

/**
 * Available method IDs for the Asset GetStarted modal
 */
export type AssetGetStartedMethodId = 'integrations' | 'seeds' | 'import';

/**
 * Asset-specific get started methods
 *
 * These methods guide users through populating their attack surface:
 * - Integrations: Auto-discover assets from cloud providers
 * - Seeds: Manual definition of discovery starting points
 * - Import: Bulk upload from external tools/formats
 */
export const ASSET_GET_STARTED_METHODS: GetStartedMethod<AssetGetStartedMethodId>[] =
  [
    {
      id: 'seeds',
      title: 'Add Discovery Seeds',
      description: 'Define domains, IPs, or web apps to scan',
      icon: SeedsIcon,
      buttonLabel: 'Add Seeds',
      buttonStyle: 'primary',
    },
    {
      id: 'integrations',
      title: 'Configure Integrations',
      description: 'Connect AWS, Azure, GitHub to auto-discover assets',
      icon: IntegrationsIcon,
      buttonLabel: 'Add Integrations',
      buttonStyle: 'primary',
    },
    {
      id: 'import',
      title: 'Import Assets Directly',
      description: 'Upload from SharpHound, NSA CSaaS, or CSV',
      icon: ArrowUpTrayIcon,
      buttonLabel: 'Import Assets',
      buttonStyle: 'primary',
    },
  ];
